export const CAMPAIGN_STATUSES = {
    draft: "Draft",
    inputReady: "Input Ready",
    bannerReady: 'Banner Ready',
    requested: 'Requested',
    scheduled: "Scheduled",
    live: "Live",
    paused: "Paused",
    dead: "Expired",
    creationInProgress: "Creation In Progress",
    creationFailed: "Creation Failed",
}

export const CAMPAIGN_STATUSES_COLOR = {
    "Draft": "#555",
    "Input Ready": "#000",
    "Scheduled": "#555",
    "Campaign Live": "rgb(30 203 37)",
    "Campaign Paused": "#D92E20",
    "Campaign Dead": "#999"
}

export const campaignCTAs = {
    edit: 'Edit',
    uploadBanner: 'Upload Banner',
    editBanner: 'Edit Banner',
    decline: 'Decline',
    addDetails: 'Add Details',
    submitRequest: 'Submit Request',
    sendForApproval: 'Send For Approval',
    schedule: 'Schedule Campaign',
    editRequest: 'Edit Request',
    update: 'Update Campaign',
    pause: 'Pause',
    resume: 'Resume'
}

export const routes = {
    viewCampaigns: "/",
    campaignSummary: "/campaign",
    createCampaign: "/createCampaign",
    viewSegments: "/viewSegments",
    createSegments: "/createSegment",
}

export const events = {
    PAGE_VIEW: 'PAGE_VIEW',
    USER_LOGIN: 'USER_LOGIN',
    API_CALL: 'API_CALL',
    BUTTON_CLICK: 'BUTTON_CLICK',
    VIEW_CAMPAIGN_ANALYTICS: 'VIEW_CAMPAIGN_ANALYTICS',
    VIEW_CAMPAIGN_SUMMARY: 'VIEW_CAMPAIGN_SUMMARY',
    VIEW_CAMPAIGNS: 'VIEW_CAMPAIGNS'
}

export const productSummarySelection = "Choose Attribute To See Product Summary Here"

export const MISSING_VALUE_MESSAGE = 'Mandatory value are missing, please select value'